/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CpcDocumentMessageType {
  NoExp = 0,
  NoImp = 1,
  SeExp = 2,
  SeImp = 3,
}
